<template>
  <v-dialog v-model="resourceViewerModal" max-width="90%">
    <div style="position: relative; height: 90vh; background: white;">
      <resource-viewer
        v-if="resourceViewer.show"
        :resourceId="resourceViewer.resourceId"
      ></resource-viewer>
    </div>
  </v-dialog>
</template>

<script>
import ResourceViewer from './index';
import { mapState, mapMutations } from 'vuex';
export default {
  components: { ResourceViewer },
  computed: {
    ...mapState('views/context', ['resourceViewer']),
    resourceViewerModal: {
      get() {
        return this.resourceViewer.show;
      },
      set({ show, resourceId }) {
        this.setResourceViewer({ show, resourceId });
      }
    }
  },
  methods: {
    ...mapMutations('views/context', ['setResourceViewer'])
  }
};
</script>

<style></style>
